import { AccessToken, IDToken } from '@okta/okta-auth-js';
import {
  PreDeclarationCarOption,
  PreDeclarationCustomerOption,
} from '../commons';

export interface DossierToken {
  accessToken: AccessToken;
  idToken: IDToken;
  refreshToken: string;
  dossierNumber: string;
  login: string;
  userTypes: string[];
}

export interface PreDeclarationToken {
  accessToken: AccessToken;
  idToken: IDToken;
  refreshToken: string;
  dossierNumber?: string;
  login: string;
  userTypes?: string[];
  plateNumber: string;
  insurerId: string;
  car?: PreDeclarationCarOption;
  customer?: PreDeclarationCustomerOption;
}

export interface OpenArrivalToken {
  accessToken: AccessToken;
  idToken: IDToken;
}
